/* eslint-disable no-restricted-syntax */
import { cardBrandData, cardBrandDataMapById } from "../../utils/cardBrandData";
import CardBrandTrie from "./CardBrandTrie";

// Initialize the trie with card brand data.
// This will initialize when this file is imported.
const cardBrandTrie = new CardBrandTrie();

for (const brand of cardBrandData) {
  for (const prefix of brand.prefixes) {
    cardBrandTrie.insert(prefix, brand);
  }
}

/**
 * Determines a card number's brand using the card number itself
 * Returns "unknown" when the brand could not be determined
 */
export function getCardBrandByNumber(cardNumber: string) {
  return cardBrandTrie.search(cardNumber);
}

/**
 * Determines a card number's brand using a string representing a card brand.
 */
export function getCardBrandByName(cardNumber: string) {
  const brandMap: Record<string, string> = {
    mc: "mastercard",
    visa: "visa",
    amex: "amex",
    discover: "discover",
    diners: "diners",
    jcb: "jcb",
    unionpay: "unionpay",
  };

  const normalizedBrand = cardNumber.toLowerCase();
  const brandId = brandMap[normalizedBrand];
  return brandId ? cardBrandDataMapById[brandId] : null;
}
